import { EnumOption } from 'common/enum-value';
import { SelectOptionType } from 'utils/react-table';

type AppointmentTypeDto = {
    id: number;
    name: string;
};

export const mapAppointmentTypeToSelectOption = (tags: Array<AppointmentTypeDto>): Array<SelectOptionType> => {
    return tags.map((tag) => ({ value: tag.id, label: tag.name }));
};

export function mapAppointmentTypeToEnumOption(appointmentTypes: Array<AppointmentTypeDto>): Array<EnumOption> {
    if (!appointmentTypes) return [{ value: 0, label: 'undefined' }];
    return appointmentTypes.map((appointmentType) => ({
        value: appointmentType.id,
        label: appointmentType.name,
    }));
}

export default AppointmentTypeDto;
